import React from "react";

/**
 * One navigation row: 36px tall, radius 11, icon in a 26px tile. The active
 * row's tile is the orange gradient with glow; collapsed rows show the tile only.
 */
const SidebarItem = ({ icon: Icon, label, isActive, onClick, isCollapsed, count }) => (
  <button
    type="button"
    onClick={onClick}
    title={isCollapsed ? label : undefined}
    aria-current={isActive ? "page" : undefined}
    className={`group relative w-full flex items-center h-9 rounded-[11px] transition-colors duration-200 ${
      isCollapsed ? "justify-center" : "gap-2.5 px-1.5"
    } ${isActive ? "bg-hover text-ink" : "text-muted hover:bg-hover hover:text-ink"}`}
  >
    <span
      className={`shrink-0 flex items-center justify-center w-[26px] h-[26px] rounded-lg transition-all duration-200 ${
        isActive ? "bg-grad shadow-glow text-on-accent" : "group-hover:text-accent"
      }`}
    >
      <Icon className="w-[15px] h-[15px]" strokeWidth={isActive ? 2.25 : 1.9} />
    </span>
    {!isCollapsed && (
      <>
        <span className="flex-1 text-left text-[13.5px] font-medium whitespace-nowrap truncate">{label}</span>
        {count > 0 && (
          <span className="shrink-0 min-w-[20px] h-5 px-1.5 rounded-full bg-accent-soft text-accent-ink text-[11px] font-semibold font-mono flex items-center justify-center">
            {count}
          </span>
        )}
      </>
    )}
  </button>
);

export default SidebarItem;
